import React from "react";
import backgroundImage from "../../assets/image/inner-page/jpg/promo-bg-img.jpg";

const ContentFour = ({ className, ...rest }) => {
  return (
    <>
      <div
        className={className}
        {...rest}
        style={{ backgroundImage: `url(${backgroundImage})` }}
      >
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col-lg-8 col-md-10">
              <div
                className="text-center pt-14 pb-15 py-lg-31 dark-mode-texts"
                data-aos="zoom-in"
                data-aos-delay="500"
              >
                <h2 className="font-size-11 mb-16">
                  Siempre vamos a estar ahí para ti
                </h2>
                <p className="font-size-7 line-height-28 px-md-10 px-lg-16 px-xl-16 mb-0">
                  Lo que nos diferencia es el soporte y la atención con nuestros
                  clientes. Si lo necesitas, te ayudaremos a configurar Timeview
                  para tu empresa.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContentFour;
